import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { FAQS } from "../data/content";
import { Reveal, Overline } from "./Reveal";

export default function Faq() {
  return (
    <section id="faq" data-testid="faq-section" className="mx-auto max-w-3xl px-6 py-24 lg:py-32">
      <Reveal className="mb-12 text-center">
        <Overline>FAQ</Overline>
        <h2 className="font-head mx-auto mt-4 max-w-2xl text-4xl font-extrabold text-[#0B1220] sm:text-5xl">
          Vous vous posez ces <span className="text-[#3B82F6]">questions</span> ?
        </h2>
      </Reveal>

      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="flex flex-col gap-3">
          {FAQS.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="card-dark overflow-hidden rounded-2xl border px-6"
            >
              <AccordionTrigger className="py-5 text-left font-head text-lg font-bold text-[#0B1220] hover:no-underline [&>svg]:text-[#3B82F6]">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="pb-5 text-base leading-[1.75] text-[#5B6B85]">
                <div className="space-y-4">
                  {(Array.isArray(item.a) ? item.a : [item.a]).map((p, idx) => (
                    <p key={idx}>{p}</p>
                  ))}
                </div>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </section>
  );
}
